export const ROWCAP = 8
export const SMALL_ROWCAP = 4
export const BORDER_RADIUS = "3px"
export const ZINDEX_BASE = 1
export const LEFT_ROW_INDICATOR = 3
